import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseConsulators() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      orderType: isEmpty(state.orderType),
      question: isEmpty(state.question),
    };
    setter(errorState);

    if (errorState.orderType || errorState.question) {
      enqueueSnackbar("لطفا اطلاعات   را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetConsultants = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Consulators?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetConsultantById = (consultantId, callback) => {
    MyAxios.get(`Admin_Consulators/${consultantId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetOperators = (callback) => {
    MyAxios.get(`Admin_Consulators/Operators`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateConsultant = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_Consulators`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const AddConsultant = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Consulators`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteConsultant = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Consulators`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetConsultants,
    GetConsultantById,
    UpdateConsultant,
    AddConsultant,
    deleteConsultant,
    GetOperators,
  };
}
